import { Column, Spinner } from "@hightouch/htui";

import { useHoldsFloatingToggle } from "src/components/layout/nav/mini-nav/mini-nav-context";
import { usePageScroll } from "src/components/layout/page-scroll";
import { Paper } from "src/components/paper";

export const PaperLoader = () => {
  useHoldsFloatingToggle();
  // Inset like the page card it stands in for, which holds the window's height where the window never scrolls.
  const isInset = !usePageScroll().isWindow;
  return (
    <Paper flex={1} minHeight={0} isInset={isInset}>
      <Column flex={1} minHeight={0} align="center" justify="center">
        <Spinner size="lg" />
      </Column>
    </Paper>
  );
};
